var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDone = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 24,
  viewBox: "0 0 24 24",
  width: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "m5 13 4.29289 4.2929c.39053.3905 1.02371.3905 1.41421 0l10.2929-10.2929",
  stroke: "currentColor"
})));
export default SvgDone;